import type { ReferralAmounts } from "@warrenio/api-spec/spec.oats.gen";

export const referralAmountsExample: ReferralAmounts = {
    promoter_credit: 14.5,
    receiver_credit: 17,
    receiver_precondition_topup_sum: 0,
};
